import { render, staticRenderFns } from "./FamilyPlanManagerComponent.vue?vue&type=template&id=2dda54eb&scoped=true&"
import script from "./FamilyPlanManagerComponent.vue?vue&type=script&lang=ts&"
export * from "./FamilyPlanManagerComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyPlanManagerComponent.vue?vue&type=style&index=0&id=2dda54eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda54eb",
  null
  
)

export default component.exports